// extracted by mini-css-extract-plugin
module.exports = {"headerTitle":"Home_headerTitle__3T__V","pay":"Home_pay__3lQ4y","spinner":"Home_spinner__2hqRh"};